import { GetPersistedSessionService } from 'types/services';
import { createSessionAuthorized } from 'utils/createSession';
import { sportingAPI } from '../api';

export const getPersistedSession: GetPersistedSessionService = async () => {
  await sportingAPI.service.getUserInfo();

  return createSessionAuthorized();
};
